<dspx-card-set-base-form [formServiceEndpoint]="formServiceEndpoint"
                         [templateId]="templateId"
                         [versionNo]="versionNo"
                         [model]="model"
                         formName="DOPI Form List"
                         (onFormLoad)="formLoad($event)"
                         (onDialogSubmit)="dialogButtonClicked($event)"
                         (onActionButtonClick)="actionButtonClicked($event)"
                         (onFilter)="filterData($event)">
</dspx-card-set-base-form>
